export const correctAnswersReducer = (sum, answer) => {
    const increaseBy = (answer === null || answer === void 0 ? void 0 : answer.isCorrect) ? 1 : 0;
    return sum + increaseBy;
};
